import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import BarcodePrint from "./BarcodePrint";
import { toBarcodeLabelItem } from "../../../utils/barcodeUtils";

/**
 * Modal wrapper for single or bulk barcode label printing.
 */
const BarcodePrintModal = ({ show, onHide, product, products }) => {
	const { t } = useTranslation();

	const items = React.useMemo(() => {
		if (products?.length) {
			return products.map(toBarcodeLabelItem);
		}
		if (product) {
			return [toBarcodeLabelItem(product)];
		}
		return [];
	}, [product, products]);

	return (
		<Modal show={show} onHide={onHide} size="md" className="barcode-print-modal">
			<Modal.Header closeButton>
				<Modal.Title>{t("Print Barcode Label")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<BarcodePrint items={items} onClose={onHide} />
			</Modal.Body>
		</Modal>
	);
};

export default BarcodePrintModal;
